import { Typography, capitalize } from '@mui/material'
import { Button } from 'components'
import { tokens } from 'styles/tokens'
import { useResendEmail } from 'services/queries/use-resend-email'

interface RolesColumnProps {
  role: string
  isVerified: boolean
  email: string
}

const RolesColumn = ({ role, isVerified, email }: RolesColumnProps) => {
  const { refetch: resendEmail } = useResendEmail(email)
  return (
    <>
      {isVerified ? (
        <div style={{ display: 'flex' }}>
          <Typography style={{ marginRight: '3px', fontSize: 14 }}>
            {capitalize(role)}
          </Typography>
        </div>
      ) : (
        <Button
          onClick={() => resendEmail()}
          style={{ backgroundColor: tokens.colors.primary[500] }}
        >
          Resend email
        </Button>
      )}
    </>
  )
}

export default RolesColumn
